import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Login from 'pages/auth/login';
import Register from 'pages/auth/register';
import RegisterByInvitation from '../components/website/auth/RegisterByInvitation';
import RegistrationConfirmation from '../components/website/auth/RegistrationConfirmation';
import RequestResetPassword from 'pages/auth/request-reset-password';
import ResetPassword from 'pages/auth/reset-password';
import useWorkspaceStore from '../stores/useWorkspaceStore';

export default function AppGuestRoutes() {
  const getInvitationCode = useWorkspaceStore((s) => s.getInvitationCode);
  const finishRegistrationForInvitedUser = useWorkspaceStore(
    (s) => s.finishRegistrationForInvitedUser,
  );
  const confirmRegistration = useWorkspaceStore((s) => s.confirmRegistration);
  const resetPassword = useWorkspaceStore((s) => s.resetPassword);
  const setNewPassword = useWorkspaceStore((s) => s.setNewPassword);

  return (
    <Switch>
      <Route exact path="/register" component={Register} />
      <Route exact path="/login" component={Login} />
      <Route
        path="/accounts/register"
        render={() => (
          <RegisterByInvitation
            getInvitationCode={getInvitationCode}
            finishRegistration={finishRegistrationForInvitedUser}
          />
        )}
      />
      <Route
        path="/confirm-registration"
        render={() => (
          <RegistrationConfirmation confirmRegistration={confirmRegistration} />
        )}
      />
      <Route
        path="/request-reset-password"
        render={() => <RequestResetPassword onReset={resetPassword} />}
      />
      <Route
        path="/reset-password"
        render={() => <ResetPassword setNewPassword={setNewPassword} />}
      />
      <Redirect to="/login" />
    </Switch>
  );
}
